import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LaudoUnionService } from 'src/app/services/http/laudo-union.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AuditoriaService } from 'src/app/services/http/auditoria.service';
import { AuthGuardService } from 'src/app/services/auth-guard-service';

@Component({
  selector: 'app-form-associacao-auditoria',
  templateUrl: './form-associacao-auditoria.component.html',
  styleUrls: ['./form-associacao-auditoria.component.scss']
})

export class FormAssociacaoAuditoriaComponent implements OnInit {

  @Output() formulario = new EventEmitter();

  associacaoAuditoria;

  params = {
    filter: {
    },
    sorting: {
      nomeFantasia: 'asc',
      nomeAuditor: 'asc'
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  form = new FormGroup({
    cliente: new FormControl('', Validators.required),
    auditor: new FormControl('', Validators.required)
  });

  listaUnidadesClientes = [{ nomeFantasia: '', id: '' }];
  listaUnidadesAuditora = [{ nomeFantasia: '', id: '' }];
  
  id = null;
  cliente = null;
  tipoUnidade: any;
  
  constructor(private laudoUnionService: LaudoUnionService, private auditoriaService: AuditoriaService, private router: Router, private route: ActivatedRoute, private authGuard: AuthGuardService) {
    this.id = this.route.snapshot.params.id;    
  }

  ngOnInit() {
    this.tipoUnidade = this.authGuard.user.unidade.tipoUnidade.nome;

    this.auditoriaService.getUnidadesClientes().then(r => {
      this.listaUnidadesClientes = this.listaUnidadesClientes.concat(r);
      this.editForm();
    });
    
    this.auditoriaService.getUnidadesAuditoras().then(r => { 
      this.listaUnidadesAuditora = this.listaUnidadesAuditora.concat(r)
    });
  }

  editForm() {

    if (this.id) {
      this.cliente = this.listaUnidadesClientes.find(v => v.id == this.id);
      let cliente = this.cliente;
      this.form.controls.cliente.patchValue(this.cliente);
    }

  }

  sendForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let cliente = this.form.controls.cliente.value;

    let dados = {
      unidadeAuditora: parseInt(this.form.controls.auditor.value),
      unidadeCliente: cliente.id,
    }

    this.auditoriaService.salvarAssociacaoAuditoria(dados).then(r => this.formulario.emit());

  }

}
